@if (!isLoading) {
  <div class="container">
    <div class="row">
      <div
        class="col-md-8 col-sm-10 offset-md-2 offset-sm-1 text-center mb-4"
        >
        <div class="text-center">
          <img
            src="/assets/images/octopus-logo-white.png"
            alt="Octopus"
            class="mb-4 img-fluid octopus-header"
            width="45%"
            />
          <p>
            You need to login again to see your driver dashboard. Please
            force the app to quit and reopen to login.
            <br />
            <br />
            <br />
            <strong>En Español:</strong>
            <br />
            Debe iniciar sesión nuevamente para ver el tablero del
            conductor. Forcé el cierre de la aplicación y vuelva a
            abrirla para iniciar sesión.
          </p>
        </div>
      </div>
    </div>
  </div>
}

@if (!isLoading) {
  <img
    src="/assets/images/polishing_tablet.png"
    alt="Polishing Tablet"
    class="bottom-centered-image"
    />
}

@if (isLoading) {
  <div class="loader">
    <mat-spinner [diameter]="100" color="accent"></mat-spinner>
  </div>
}
